import { Component } from "@angular/core";

@Component({
    selector: 'giq-small-load',
    templateUrl: 'small-load.component.html',
    styleUrls: ['small-load.component.scss'],
    standalone: false
})
export class SmallLoadComponent {

}